import {GlobalVariables} from "../GlobalVariables";
import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BlockTabs {
	static init() {
		this.collapses = document.querySelectorAll(".block-text-tabs .collapse");
		this.build();
		GlobalVariables.resizeCallbacks.push(this);
	}

	static build() {

		this.images = document.querySelectorAll(".block-text-tabs .collapse-image");

		this.collapses.forEach((collapse, index) => {
			const head = collapse.querySelector(".collapse-head");
			collapse.body = collapse.querySelector(".collapse-body");
			collapse.body.dataset.height = collapse.body.clientHeight;

			if( window.innerWidth > 992 ) {
				collapse.body.style.height = 0;
			}

			if(index === 0){
				this.openElement(collapse, index);
			}

			head.addEventListener("click", () => {
				if (!collapse.classList.contains("open")) {
					this.collapses.forEach(col => {
						this.closeElement(col);
					});
					this.openElement(collapse, index);
				}
			});
		});
	}

	static closeElement(collapse, index){
		collapse.classList.remove("open");
		gsap.to(collapse.body, {
			height: 0,
			duration: 0.5,
			onComplete: () => ScrollTrigger.refresh()
		});
	}

	static openElement(collapse, index){
		collapse.classList.add("open");
		gsap.to(collapse.body, {
			height: collapse.body.dataset.height,
			duration: 0.5,
			onComplete: () => ScrollTrigger.refresh()
		});
		this.images.forEach( (image, i) => {
			image.classList.toggle('collapse-image-visible', i === index);
		});
	}

	static resize() {

		if( window.innerWidth > 992 ){

			this.collapses.forEach(collapse => {
				const body = collapse.querySelector(".collapse-body");
				body.style.height = "auto";
				body.dataset.height = body.clientHeight;
				if (!collapse.classList.contains("open")) {
					body.style.height = 0;
				}
			});

		} else {

			this.collapses.forEach(collapse => {
				const body = collapse.querySelector(".collapse-body");
				body.style.height = "auto";
			});

		}

	}
}
